import { generateRecentTimestamp } from "../utils/timestamp";

const drivers = {
  drivers: [
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Ahmed Al Mansoori", // Abu Dhabi-based name
      speed: "10 mph",
      workStatus: "On Trip",
      violations: "5",
      distanceCovered: "20 Miles",
      route: "Route#1",
      licenseNo: "DRV#123456",
      busNo: "Bus#1",
      trips: "453",
      safetyScore: "56",
      passenger: "543",
      avgFuelEconomy: "40 Miles/Gal",
      busLicensePlateNo: "PB2586",
      nextMaintanance: "09-25-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: { lat: "24.5015", lng: "54.3850" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: { lat: "24.4833", lng: "54.3833" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: { lat: "24.4667", lng: "54.3333" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.3500" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.3667" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: { lat: "24.4885", lng: "54.6050" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: { lat: "24.4333", lng: "54.4333" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: { lat: "24.4167", lng: "54.4500" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.4667" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.4833" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: { lat: "24.4167", lng: "54.5167" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: { lat: "24.4333", lng: "54.5000" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#2",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Reem Island, Abu Dhabi",
        coOrdinates: { lat: 24.4833, lng: 54.3833 },
      },
      destination: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: { lat: 24.4667, lng: 54.3333 },
      },
      currentLocation: {
        area: "Al Reem Island, Abu Dhabi",
        coOrdinates: { lat: 24.4833, lng: 54.3833 },
      },
      nextStop: {
        area: "Al Maryah Island, Abu Dhabi",
        coOrdinates: { lat: 24.5015, lng: 54.3850 },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Ahmed Al Mansoori",
      speed: "10 mph",
      workStatus: "On Trip",
      violations: "5",
      distanceCovered: "20 Miles",
      route: "Route#1",
      licenseNo: "DRV#123456",
      busNo: "Bus#1",
      trips: "453",
      safetyScore: "56",
      passenger: "543",
      avgFuelEconomy: "40 Miles/Gal",
      busLicensePlateNo: "PB2586",
      nextMaintanance: "09-25-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: { lat: "24.5015", lng: "54.3850" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: { lat: "24.4833", lng: "54.3833" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: { lat: "24.4667", lng: "54.3333" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.3500" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.3667" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: { lat: "24.4885", lng: "54.6050" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: { lat: "24.4333", lng: "54.4333" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: { lat: "24.4167", lng: "54.4500" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.4667" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: { lat: "24.4500", lng: "54.4833" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: { lat: "24.4167", lng: "54.5167" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: { lat: "24.4333", lng: "54.5000" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#2",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Reem Island, Abu Dhabi",
        coOrdinates: { lat: 24.4833, lng: 54.3833 },
      },
      destination: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: { lat: 24.4667, lng: 54.3333 },
      },
      currentLocation: {
        area: "Al Reem Island, Abu Dhabi",
        coOrdinates: { lat: 24.4833, lng: 54.3833 },
      },
      nextStop: {
        area: "Al Maryah Island, Abu Dhabi",
        coOrdinates: { lat: 24.5015, lng: 54.3850 },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Salem bin Nasser",
      speed: "17 mph",
      workStatus: "On Trip",
      violations: "3",
      distanceCovered: "28 Miles",
      route: "Route#11",
      licenseNo: "DRV#246810",
      busNo: "Bus#28",
      trips: "327",
      safetyScore: "73",
      passenger: "402",
      avgFuelEconomy: "38 Miles/Gal",
      busLicensePlateNo: "AD7891",
      nextMaintanance: "11-11-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "17 mph",
          fuelConsumed: "14 Gal",
          distanceCovered: "28 Miles",
          driver: "Salem bin Nasser",
          tripStatus: "In Progress",
          distance: "95 Miles",
          routeDetails: {
            route: "Route#11",
            occupancy: "21/35",
            videoUrl: "http://busVideoRoute11A",
            routeStops: {
              totalStops: "6",
              stopsCovered: "4",
              stoppages: [
                {
                  name: "Source",
                  observation: "Early Departure",
                  area: "Al Danah, Abu Dhabi",
                  coOrdinates: { lat: "24.4961", lng: "54.3709" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Normal",
                  area: "Electra Street, Abu Dhabi",
                  coOrdinates: { lat: "24.4925", lng: "54.3795" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Mina, Abu Dhabi",
                  coOrdinates: { lat: "24.5046", lng: "54.3715" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Saadiyat Island, Abu Dhabi",
                  coOrdinates: { lat: "24.5325", lng: "54.4244" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Sheikh Zayed Grand Mosque, Abu Dhabi",
                  coOrdinates: { lat: "24.4120", lng: "54.4749" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: { lat: "24.4181", lng: "54.4825" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "20 mph",
          fuelConsumed: "17 Gal",
          distanceCovered: "32 Miles",
          driver: "Mariam Al Rashedi",
          tripStatus: "Completed",
          distance: "112 Miles",
          routeDetails: {
            route: "Route#26",
            occupancy: "26/40",
            videoUrl: "http://busVideoRoute26B",
            routeStops: {
              totalStops: "5",
              stopsCovered: "5",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Al Muntazah, Abu Dhabi",
                  coOrdinates: { lat: "24.4258", lng: "54.4664" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Passenger Pickup",
                  area: "Sheikh Rashid Bin Saeed St, Abu Dhabi",
                  coOrdinates: { lat: "24.4501", lng: "54.3923" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Mushrif Mall, Abu Dhabi",
                  coOrdinates: { lat: "24.4404", lng: "54.3862" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Nahyan, Abu Dhabi",
                  coOrdinates: { lat: "24.4667", lng: "54.3667" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Zahiyah, Abu Dhabi",
                  coOrdinates: { lat: "24.4949", lng: "54.3703" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "hard acceleration",
          busNo: "28",
          route: "Route#11",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "28",
          route: "Route#26",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "signal jump",
          busNo: "28",
          route: "Route#26",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Danah, Abu Dhabi",
        coOrdinates: { lat: 24.4961, lng: 54.3709 },
      },
      destination: {
        area: "Khalifa Park, Abu Dhabi",
        coOrdinates: { lat: 24.4181, lng: 54.4825 },
      },
      currentLocation: {
        area: "Electra Street, Abu Dhabi",
        coOrdinates: { lat: 24.4925, lng: 54.3795 },
      },
      nextStop: {
        area: "Al Mina, Abu Dhabi",
        coOrdinates: { lat: 24.5046, lng: 54.3715 },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Hessa Al Shehhi",
      speed: "22 mph",
      workStatus: "On Trip",
      violations: "1",
      distanceCovered: "41 Miles",
      route: "Route#21",
      licenseNo: "DRV#112233",
      busNo: "Bus#39",
      trips: "163",
      safetyScore: "89",
      passenger: "417",
      avgFuelEconomy: "37 Miles/Gal",
      busLicensePlateNo: "AD9912",
      nextMaintanance: "09-30-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "22 mph",
          fuelConsumed: "21 Gal",
          distanceCovered: "41 Miles",
          driver: "Hessa Al Shehhi",
          tripStatus: "In Progress",
          distance: "130 Miles",
          routeDetails: {
            route: "Route#21",
            occupancy: "14/32",
            videoUrl: "http://busVideoRoute21",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "5 Min Delay",
                  area: "Al Nahda, Abu Dhabi",
                  coOrdinates: { lat: "24.4153", lng: "54.4188" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Normal",
                  area: "Al Maqta, Abu Dhabi",
                  coOrdinates: { lat: "24.3876", lng: "54.5041" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Qaryat Al Beri Souq, Abu Dhabi",
                  coOrdinates: { lat: "24.4217", lng: "54.5582" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: { lat: "24.5015", lng: "54.3850" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Falah Street, Abu Dhabi",
                  coOrdinates: { lat: "24.4927", lng: "54.3685" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "18 mph",
          fuelConsumed: "16 Gal",
          distanceCovered: "32 Miles",
          driver: "Majid Al Shamsi",
          tripStatus: "Completed",
          distance: "108 Miles",
          routeDetails: {
            route: "Route#42",
            occupancy: "18/30",
            videoUrl: "http://busVideoRoute42",
            routeStops: {
              totalStops: "6",
              stopsCovered: "6",
              stoppages: [
                {
                  name: "Source",
                  observation: "On Time",
                  area: "Zayed Port, Abu Dhabi",
                  coOrdinates: { lat: "24.5333", lng: "54.3889" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Sharp Turn",
                  area: "Hamouda Bin Ali Al Dhaheri St, Abu Dhabi",
                  coOrdinates: { lat: "24.5101", lng: "54.3887" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Rawdah, Abu Dhabi",
                  coOrdinates: { lat: "24.4476", lng: "54.4189" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Saif Ghobash Street, Abu Dhabi",
                  coOrdinates: { lat: "24.4291", lng: "54.4511" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Mushrif, Abu Dhabi",
                  coOrdinates: { lat: "24.4347", lng: "54.3852" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Abu Dhabi Courts, Abu Dhabi",
                  coOrdinates: { lat: "24.4412", lng: "54.3665" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "3",
          speed: "20 mph",
          fuelConsumed: "19 Gal",
          distanceCovered: "35 Miles",
          driver: "Sara Al Romaithi",
          tripStatus: "In Progress",
          distance: "115 Miles",
          routeDetails: {
            route: "Route#56",
            occupancy: "20/34",
            videoUrl: "http://busVideoRoute56",
            routeStops: {
              totalStops: "5",
              stopsCovered: "4",
              stoppages: [
                {
                  name: "Source",
                  observation: "Start",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: { lat: "24.4934", lng: "54.4103" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Boarding",
                  area: "City of Lights, Al Reem, Abu Dhabi",
                  coOrdinates: { lat: "24.4957", lng: "54.3998" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Rabdan, Abu Dhabi",
                  coOrdinates: { lat: "24.4264", lng: "54.5308" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: { lat: "24.4628", lng: "54.3255" },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Wahat Al Karamah, Abu Dhabi",
                  coOrdinates: { lat: "24.4286", lng: "54.4551" },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "seatbelt violation",
          busNo: "39",
          route: "Route#21",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overcrowding",
          busNo: "39",
          route: "Route#42",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "lane departure",
          busNo: "39",
          route: "Route#56",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Nahda, Abu Dhabi",
        coOrdinates: { lat: 24.4153, lng: 54.4188 },
      },
      destination: {
        area: "Al Falah Street, Abu Dhabi",
        coOrdinates: { lat: 24.4927, lng: 54.3685 },
      },
      currentLocation: {
        area: "Al Maqta, Abu Dhabi",
        coOrdinates: { lat: 24.3876, lng: 54.5041 },
      },
      nextStop: {
        area: "Qaryat Al Beri Souq, Abu Dhabi",
        coOrdinates: { lat: 24.4217, lng: 54.5582 },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Irfan Pathan",
      speed: "10 mph",
      workStatus: "On Trip",
      violations: "5",
      distanceCovered: "20 Miles",
      route: "Route#1",
      licenseNo: "DRV#123456",
      busNo: "Bus#1",
      trips: "453",
      safetyScore: "56",
      passenger: "543",
      avgFuelEconomy: "40 Miles/Gal",
      busLicensePlateNo: "PB2586",
      nextMaintanance: "09-25-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5015",
                    lng: "54.3850"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4667",
                    lng: "54.3333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4885",
                    lng: "54.6050"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Zahiyah, Abu Dhabi",
        coOrdinates: {
          lat: 24.4830,
          lng: 54.3600,
        },
      },
      destination: {
        area: "Al Khalidiyah, Abu Dhabi",
        coOrdinates: {
          lat: 24.5067,
          lng: 54.3604,
        },
      },
      currentLocation: {
        area: "Al Nahyan, Abu Dhabi",
        coOrdinates: {
          lat: 24.4706,
          lng: 54.3773,
        },
      },
      nextStop: {
        area: "Corniche Road, Abu Dhabi",
        coOrdinates: {
          lat: 24.4822,
          lng: 54.3464,
        },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Azaharuddin",
      speed: "10 mph",
      workStatus: "On Trip",
      violations: "5",
      distanceCovered: "20 Miles",
      route: "Route#1",
      licenseNo: "DRV#123456",
      busNo: "Bus#1",
      trips: "453",
      safetyScore: "56",
      passenger: "543",
      avgFuelEconomy: "40 Miles/Gal",
      busLicensePlateNo: "PB2586",
      nextMaintanance: "09-25-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5015",
                    lng: "54.3850"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4667",
                    lng: "54.3333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4885",
                    lng: "54.6050"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Zahiyah, Abu Dhabi",
        coOrdinates: {
          lat: 24.4800,
          lng: 54.3550,
        },
      },
      destination: {
        area: "Al Raha Beach, Abu Dhabi",
        coOrdinates: {
          lat: 24.4865,
          lng: 54.4087,
        },
      },
      currentLocation: {
        area: "Khalifa City A, Abu Dhabi",
        coOrdinates: {
          lat: 24.4243,
          lng: 54.5811,
        },
      },
      nextStop: {
        area: "Emirates Palace, Abu Dhabi",
        coOrdinates: {
          lat: 24.4666,
          lng: 54.3213,
        },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Mohammed Kaif",
      speed: "10 mph",
      workStatus: "On Trip",
      violations: "5",
      distanceCovered: "20 Miles",
      route: "Route#1",
      licenseNo: "DRV#123456",
      busNo: "Bus#1",
      trips: "453",
      safetyScore: "56",
      passenger: "543",
      avgFuelEconomy: "40 Miles/Gal",
      busLicensePlateNo: "PB2586",
      nextMaintanance: "09-25-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5015",
                    lng: "54.3850"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4667",
                    lng: "54.3333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4885",
                    lng: "54.6050"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Maryah Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.4905,
          lng: 54.3668,
        },
      },
      destination: {
        area: "Yas Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.4958,
          lng: 54.6061,
        },
      },
      currentLocation: {
        area: "Al Reem Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.5229,
          lng: 54.4031,
        },
      },
      nextStop: {
        area: "Corniche Area, Abu Dhabi",
        coOrdinates: {
          lat: 24.4861,
          lng: 54.3571,
        },
      },
    },
    {
      avatarImg:
        "https://images.unsplash.com/photo-1599566150163-29194dcaad36?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=687&q=80",
      driver: "Noor Ahmed",
      speed: "10 mph",
      workStatus: "On Trip",
      violations: "5",
      distanceCovered: "20 Miles",
      route: "Route#1",
      licenseNo: "DRV#123456",
      busNo: "Bus#1",
      trips: "453",
      safetyScore: "56",
      passenger: "543",
      avgFuelEconomy: "40 Miles/Gal",
      busLicensePlateNo: "PB2586",
      nextMaintanance: "09-25-2025",
      timeStamp: generateRecentTimestamp(),
      trip: [
        {
          tripNo: "1",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "In Progress",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#1",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Al Maryah Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.5015",
                    lng: "54.3850"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Reem Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4833",
                    lng: "54.3833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Corniche Road, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4667",
                    lng: "54.3333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Bateen, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Al Karamah, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.3667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Yas Island, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4885",
                    lng: "54.6050"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
        {
          tripNo: "2",
          speed: "10 mph",
          fuelConsumed: "20 Gal",
          distanceCovered: "20 Miles",
          driver: "Ahmed Al Mansoori",
          tripStatus: "Completed",
          distance: "150 Miles",
          routeDetails: {
            route: "Route#2",
            occupancy: "20/40",
            videoUrl: "http://busVideo",
            routeStops: {
              totalStops: "5",
              stopsCovered: "3",
              stoppages: [
                {
                  name: "Source",
                  observation: "15 Min Delay",
                  area: "Khalifa City, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.4333"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Current Location",
                  observation: "Over Speeding",
                  area: "Al Bahia, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.4500"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 1",
                  observation: "Next Stop",
                  area: "Al Raha Beach, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4667"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 2",
                  observation: "",
                  area: "Al Raha Gardens, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4500",
                    lng: "54.4833"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Stop 3",
                  observation: "",
                  area: "Khalifa Park, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4167",
                    lng: "54.5167"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
                {
                  name: "Destination",
                  observation: "",
                  area: "Al Raha Mall, Abu Dhabi",
                  coOrdinates: {
                    lat: "24.4333",
                    lng: "54.5000"
                  },
                  timeStamp: generateRecentTimestamp(),
                },
              ],
            },
          },
        },
      ],
      pastViolations: [
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
        {
          violationType: "overspeeding",
          busNo: "1",
          route: "Route#1",
          timeStamp: generateRecentTimestamp(),
        },
      ],
      source: {
        area: "Al Maryah Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.4905,
          lng: 54.3668,
        },
      },
      destination: {
        area: "Yas Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.4958,
          lng: 54.6061,
        },
      },
      currentLocation: {
        area: "Al Reem Island, Abu Dhabi",
        coOrdinates: {
          lat: 24.5229,
          lng: 54.4031,
        },
      },
      nextStop: {
        area: "Abu Dhabi Corniche",
        coOrdinates: {
          lat: 24.4861,
          lng: 54.3571,
        },
      },
    },
  ],
};
export default drivers;


